import {createFeatureSelector, createSelector} from '@ngrx/store';
import {SharedStoreFeatureKey} from './shared-store.config';
import {ShareStoreDTO} from './shared-store.dto';
import {documentsTypeAdapter} from './shared-store.reducer';

export const sharedStoreState = createFeatureSelector<ShareStoreDTO>(SharedStoreFeatureKey);





const {selectAll: selectAllDocumentTypes} = documentsTypeAdapter.getSelectors();


export const activities = createSelector(sharedStoreState, (state) => state.activities);
export const activitiesLoader = createSelector(sharedStoreState, (state) => state.activitiesLoader);
export const sendInternalChatFormLoader = createSelector(sharedStoreState, (state) => state.sendInternalChatFormLoader);
export const users = createSelector(sharedStoreState, (state) => state.users);
export const documentTypeSelectors = createSelector(sharedStoreState, (state) => state.documentTypes)
export const documentTypes = createSelector(documentTypeSelectors, selectAllDocumentTypes);
export const getDocumentTypeById = (documentTypeId: number) => createSelector(documentTypes, (documentTypes) => documentTypes.find(x => x.id == documentTypeId));
export const isDocumentTypesLoading = createSelector(sharedStoreState, (state) => state.isDocumentTypesLoading);
export const userTimezone = createSelector(sharedStoreState, (state) => state?.user_timezone);
